import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'get_damagePolicy';

const damagePolicyQuery = `
    query quote($createCheckoutRequest: CreateCheckoutRequest) {
        quote(createCheckoutRequest: $createCheckoutRequest) {
            policies{
                type
                damageLiability {
                    damageLiabilityAmount {
                        localized
                    }
                }
           }
        }
    }
`;

async function damagePolicyGraphQl(
    {unit, pointOfSaleId, arrivalDate, departureDate, adults},
    locale
) {
    const queryVariables = {
        unit,
        pointOfSaleId,
        arrivalDate,
        departureDate,
        adults
    };

    return await graphqlQuery(
        OPERATION_NAME,
        damagePolicyQuery,
        {createCheckoutRequest: queryVariables},
        locale
    );
}

export default damagePolicyGraphQl;
export {damagePolicyGraphQl, OPERATION_NAME, damagePolicyQuery};
